import React from "react";
import { View, Text } from "react-native";
import Typography from "../../typography/Typography";
import { TypographyTypeDLS } from "@voltmoney/schema";
const FailureNote = ({ failedTitle, progressTitle, status, }) => {
    return (React.createElement(View, { style: { flexDirection: 'row', backgroundColor: '#FEF4E6', paddingHorizontal: 16, paddingVertical: 8, borderRadius: 8 } },
        React.createElement(Text, null,
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2B, label: "Note: " }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: status === 'Pending' ? progressTitle : failedTitle }))));
};
export default FailureNote;
